import * as React from 'react';
import classNames from 'classnames';
import Icon from '@ant-design/icons';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Button from 'antd/es/button';
import { ReactComponent as EditIcon } from '../../../assets/icons/pencil/penIcon.svg';
import { ReactComponent as QuickRepliesGreenPlus } from '../../../assets/icons/plus/greenPlus.svg';
import { ReactComponent as QuickRepliesDeleteIcon } from '../../../assets/icons/deleteIcon/deleteIcon.svg';
import { Operation } from '../index';
import styles from '../EntityManager.module.scss';
function Header({ operation, title, onMobileBack, isRTL }) {
    const renderIcon = () => {
        switch (operation) {
            case Operation.CREATE:
                return React.createElement(Icon, { className: styles.titleIcon, component: QuickRepliesGreenPlus });
            case Operation.EDIT:
                return React.createElement(Icon, { className: styles.titleIcon, component: EditIcon });
            case Operation.DELETE:
                return React.createElement(Icon, { className: styles.titleIcon, component: QuickRepliesDeleteIcon });
            default:
                return null;
        }
    };
    if (operation === Operation.LIST) {
        return null;
    }
    return (React.createElement("div", { className: styles.header },
        React.createElement("div", { className: classNames(styles.title, {
                [styles.titleGreen]: operation !== Operation.DELETE,
                [styles.titleRed]: operation === Operation.DELETE,
            }) },
            onMobileBack && (React.createElement(Button, { type: "text", icon: isRTL ? React.createElement(ArrowRightOutlined, null) : React.createElement(ArrowLeftOutlined, null), onClick: onMobileBack, className: styles.backButtonMobile })),
            renderIcon(),
            title)));
}
export default Header;
